import { Stack, Typography } from "@mui/material";

export default function ShotHeader({ label }: { label: string }) {
  return (
    <Stack sx={{ alignItems: "center" }}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {label}
      </Typography>
      <Typography variant="caption" sx={{ color: "text.secondary", fontFamily: "monospace" }}>
        Unc. | Lite | Hvy
      </Typography>
    </Stack>
  );
}
